import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    IJourneyItem, UpgradeHelper, AdminToolHelper, AdminToolPanelHelper, IAdminToolPanel
} from '../../../helpers';
import { PAGING_ITEM_AMOUNT } from '../../../constants';
import { Button, ButtonType } from 'office-ui-fabric-react';
import { PanelHeader } from '../../admintool/panelheader';
import { SearchFilter } from '../../admintool/searchfilter';
import { ListPaging } from '../../admintool/panels/listpaging';


interface IProps {
    adminToolState: any;
    showStatus: boolean;
    enableRemoveButtons: boolean;
    panelName: string;
    panelTitle: string;
}
export class AdminToolList extends React.Component<IProps, any> {
    componentDidMount() {
        AdminToolPanelHelper.SetUpPanelState(this.props.adminToolState, this.props.panelName, true);
    }


    removeAllButtonClick() {
        AdminToolHelper.ClearProcessList();
    }
    removeItemButtonClick(journeyId: string) {
        AdminToolHelper.RemoveToProcessList(journeyId);
    }

    searchFilters(adminToolList: any, panel: IAdminToolPanel) {
        if (adminToolList) {

            let search: string = AdminToolPanelHelper.GetSearchFilters(panel);
            if (search) {
                adminToolList = (adminToolList.filter(value => value.journeyId && value.journeyId.indexOf(search) > -1 ||
                    value.journeyName && value.journeyName.indexOf(search) > -1 ||
                    value.upgradeStatus && value.upgradeStatus.indexOf(search) > -1));
            }
        }

        return adminToolList;
    }
    render() {
        let panel: IAdminToolPanel = AdminToolPanelHelper.GetPanel(this.props.adminToolState, this.props.panelName);
        let result: any = this.searchFilters(this.props.adminToolState.processList[this.props.adminToolState.tab], panel);

        var mapResults = result.map((result: IJourneyItem, index: any) => {
            return (<tr key={index}>
                <td>{result.journeyName}</td>
                <td>{result.journeyId}</td>
                <td>{result.version}</td>
                {this.props.enableRemoveButtons && <td><Button icon="Delete"
                    buttonType={ButtonType.icon}
                    onClick={() => { this.removeItemButtonClick(result.journeyId); }}
                    title='Remove this journey from upgrade list' /></td>}
                {this.props.showStatus && <td>{result.upgradeStatus}</td>}
            </tr>
            );
        });

        let pagingNumber: number = AdminToolPanelHelper.GetPaging(panel);
        mapResults = mapResults.slice(pagingNumber, pagingNumber + PAGING_ITEM_AMOUNT);
        let displayed: boolean = AdminToolPanelHelper.IsPanelDisplayed(panel);
        let textBoxValue: string = "";
        return (<div className="selectedupgradedjourneys admintool-panelcontainer">
            <PanelHeader panelName={this.props.panelName} panelTitle={this.props.panelTitle} enableToggle={true} isEnabled={displayed} adminToolState={this.props.adminToolState} />
            <div className="panel-content" style={!displayed ? { display: 'none' } : {}}>
                <SearchFilter disable={false} adminToolState={this.props.adminToolState} panelName={this.props.panelName} />
                <table>
                    <tbody>
                        <tr key="columns">
                            <td>Name</td>
                            <td>Journey Id</td>
                            <td>Version</td>
                            {this.props.showStatus && <td>Status</td>}
                            {this.props.enableRemoveButtons && <td>Remove</td>}
                        </tr>
                        {
                            mapResults
                        }
                    </tbody>
                </table>
                <br />
                {this.props.enableRemoveButtons && <Button
                    icon="Delete" disabled={(this.props.adminToolState.processList[this.props.adminToolState.tab].length > 0) ? false : true}
                    buttonType={ButtonType.primary}
                    onClick={() => this.removeAllButtonClick()}>
                    Remove All</Button>}
                <br />
                <ListPaging disable={false} panelName={this.props.panelName} adminToolState={this.props.adminToolState} pagingNumber={pagingNumber} pagingMax={pagingNumber + PAGING_ITEM_AMOUNT} list={result} />
            </div>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./source/ts/components/admintool/panels/admintoollist.tsx